import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Space,
  InputNumber,
} from 'antd';
import moment from 'moment';
import DebounceSelect from '../../Forms/DebounceSelect';
import formatAmount from 'indian-currency-formatter';
import * as Config from '../../../appConfig';
import { activePeriod, disabledDate, isSunday } from '../../../utils/date';

const AddPaymentForm = ({
  payment,
  lookupData,
  onLookup,
  onPaymentSubmit,
  onCancelClick,
  fetching,
  ability,
}) => {
  const [form] = Form.useForm();

  // TODO: client side caching for employee auto complete
  const [selectedEmployee, setSelectedEmployee] = React.useState(
    payment
      ? {
          value: `${payment.employee.id}`,
          label: `${payment.employee.first_name} ${payment.employee.last_name} (${payment.employee.emp_id})`,
        }
      : {}
  );

  console.log('selectedEmployee ////', selectedEmployee);

  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        initialValues={{
          id: payment && payment.id,
          payment_type_id:
            payment && payment.payment_type && payment.payment_type.id,
          for_month: payment && payment.for_month && moment(payment.for_month),
          amount: payment && payment.amount,
          note: payment && payment.note,
          employee: selectedEmployee,
        }}
        onFinish={(values) =>
          onPaymentSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Employee"
              name="employee"
              rules={[
                {
                  required: true,
                  message: 'Please input Employee!',
                },
              ]}
            >
              <DebounceSelect
                showSearch={payment && payment.id ? false : true}
                disabled={payment && payment.id ? true : false}
                defaultValue={selectedEmployee}
                value={selectedEmployee}
                placeholder="Search employee"
                data={
                  lookupData && lookupData.length
                    ? lookupData
                    : payment
                    ? [
                        {
                          label: `${payment.employee.first_name} ${payment.employee.last_name} (${payment.employee.emp_id})`,
                          value: payment.employee.id,
                        },
                      ]
                    : []
                }
                onLookup={onLookup}
                onChange={(newValue) => {
                  setSelectedEmployee(newValue);
                }}
                style={{
                  width: '100%',
                }}
                fetching={fetching}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Month"
              name="for_month"
              rules={[
                {
                  required: true,
                  message: 'Please select Month!',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) =>
                  disabledDate(
                    current,
                    false,
                    currentMonth,
                    prevMonth
                  ) || isSunday(current)
                }
                format={Config.DATE_MONTH_INPUT}
                picker="month"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: 'Please input Amount!',
                },
              ]}
            >
              <InputNumber
                formatter={(value) => formatAmount(value)}
                parser={(value) => value.replace(/(,*)/g, '')}
                style={{
                  width: '170px',
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Save
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default AddPaymentForm;
